import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import API_CONFIG from './config/api';
import { getToken } from './api/client';

// Interceptor: envia token ISG nas requisições ao backend (FASE 0/1 multi-tenant).
// Não sobrescreve Authorization já definido (ex.: portal do prestador) nem aplica em rotas /api/prestador/*.
const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const token = getToken();
  const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
  const isBackend = token && urlStr.startsWith(API_CONFIG.BACKEND_URL);
  const isPrestadorApi = /\/api\/prestador(\/|$)/.test(urlStr) || /\/api\/auth\/prestador\//.test(urlStr);

  if (isBackend && !isPrestadorApi) {
    const headers = { ...(options.headers || {}) };
    const hasAuth = Object.keys(headers).some((k) => k.toLowerCase() === 'authorization');
    if (!hasAuth) {
      headers.Authorization = `Bearer ${token}`;
    }
    options = { ...options, headers };
  }
  return originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Registra o service worker para cache offline
serviceWorkerRegistration.register();

// Ativa funções de status online/offline
serviceWorkerRegistration.syncWhenOnline();
serviceWorkerRegistration.showOfflineStatus();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
